import { SugarMoneyApiMakeApiRequestType } from 'types/api-internal';
import {
  SugarMoneyApiCoinMetadataType,
  SugarMoneyApiCoinMetadataOperationEnum,
  SugarMoneyApiPostCoinMetadataResponse,
  SugarMoneyApiCoinMetadataStatusEnum,
} from '../../types/coin';
export const uploadMetadata = async ({
  file,
  metadata,
  operation,
  makeApiRequest,
}: {
  file: File;
  metadata: SugarMoneyApiCoinMetadataType;
  operation: SugarMoneyApiCoinMetadataOperationEnum;
  makeApiRequest: SugarMoneyApiMakeApiRequestType;
}): Promise<{ data: SugarMoneyApiPostCoinMetadataResponse | null; error: Error | null }> => {
  const CHUNK_SIZE = 4 * 1024 * 1024;
  const totalChunks = Math.ceil(file.size / CHUNK_SIZE);
  const fileId = crypto.randomUUID();

  const chunkToBase64 = async (chunk: Blob): Promise<string> => {
    const arrayBuffer = await chunk.arrayBuffer();
    const buffer = Buffer.from(arrayBuffer);
    return buffer.toString('base64');
  };

  try {
    for (let i = 0; i < totalChunks; i++) {
      const start = i * CHUNK_SIZE;
      const end = Math.min(start + CHUNK_SIZE, file.size);
      const chunk = file.slice(start, end);
      const base64Chunk = await chunkToBase64(chunk);
      const response = await makeApiRequest<SugarMoneyApiPostCoinMetadataResponse>({
        endpoint: '/coin/metadata',
        data: {
          operation,
          metadata: i === totalChunks - 1 ? metadata : undefined,
          fileId,
          chunkIndex: i,
          totalChunks,
          chunk: base64Chunk,
        },
        options: { method: 'post' },
      });

      if (
        response &&
        typeof response === 'string' &&
        operation === SugarMoneyApiCoinMetadataOperationEnum.IpfsUrlForMetadata
      ) {
        return { data: response, error: null };
      }

      if (
        response &&
        typeof response === 'object' &&
        'status' in response &&
        response.status === SugarMoneyApiCoinMetadataStatusEnum.Complete
      ) {
        return { data: response, error: null };
      }
    }

    return { data: null, error: new Error('Upload completed but no final response received') };
  } catch (error) {
    return {
      data: null,
      error: new Error(
        operation === SugarMoneyApiCoinMetadataOperationEnum.IpfsUrlForMetadata
          ? 'Error generating metadata IPFS URL'
          : 'Error creating coin',
      ),
    };
  }
};
